<template>
  <div>
    <guide-use title="IP画像-在线API版本"></guide-use>
    <div class="risk-ip-list">
      <ul class="list-header">
        <li v-for="(item, index) in headerData" :key="index">{{item}}</li>
      </ul>
      <div class="list-body" v-for="(item,index) in ipProduct" :key="index">
        <span>{{toThousands(item['reqtotal'])}}次</span>
        <span>{{toThousands(item['reqtotal'] - item['reqused'])}}次</span>
        <span>{{item.ctime}}</span>
        <span>{{item.expire}}</span>
        <span>{{rank(item.auditflag)}}</span>
      </div>
    </div>
    <chart-ip version="blackipv2"></chart-ip>
  </div>
</template>

<script>
import ChartIp from './chart/index.vue'
import guideUse from '../../../components/mark/guideUse'
import { toThousands } from '../../../util/common'
export default {
  name: 'riskIpOnlineV2',
  components: { guideUse, ChartIp },
  data () {
    return {
      headerData: ['授权配额', '剩余配额', '开通时间', '截止时间', '状态']
    }
  },
  computed: {
    ipProduct () {
      return this.$store.state.product.filter(val => {
        return val.busi === 'blackipv2_online' && val.auditflag === '5'
      })
    }
  },
  methods: {
    toThousands,
    rank (k) {
      if (k === '5') {
        return '使用中'
      } else if (k === '1') {
        return '待付款'
      } else if (k === '2') {
        return '待审核'
      } else if (k === '4') {
        return '已失效'
      } else {
        return '其他状态'
      }
    }
  }
}
</script>

<style lang="scss">
.risk-ip-list {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 8px 0 rgba(17, 39, 98, 0.04);
  border-radius: 4px;
  margin-bottom: 40px;

  .list-header {
    border-bottom: 1px solid rgba(234, 237, 242, 1);

    li {
      display: inline-block;
      width: 15%;
      height: 58px;
      line-height: 58px;
      font-size: 16px;
      font-weight: 500;
      color: rgba(29, 36, 60, 1);
      text-align: center;
    }
  }

  .list-body {
    span {
      display: inline-block;
      width: 15%;
      text-align: center;
      height: 75px;
      line-height: 75px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(29, 36, 60, 1);

      .feedback {
        width: 72px;
        height: 28px;
        background: rgba(0, 61, 146, 1);
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 28px;
      }
    }
  }
}
</style>
